import { render } from "./InviteMemberModal.vue?vue&type=template&id=27bbfd3a"
import script from "./InviteMemberModal.vue?vue&type=script&lang=js"
export * from "./InviteMemberModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/InviteMemberModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27bbfd3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27bbfd3a', __exports__)) {
    api.reload('27bbfd3a', __exports__)
  }
  
  module.hot.accept("./InviteMemberModal.vue?vue&type=template&id=27bbfd3a", () => {
    api.rerender('27bbfd3a', render)
  })

}


export default __exports__